import config from '../../../config';
import LiveService from './LiveService';
import FakeService from './FakeService';

export default config.offline ? FakeService : LiveService;
